export function mergeChatMessages(current,incoming){
 const messages=new Map(current.map(message=>[Number(message.id),message]));
 for(const message of incoming)messages.set(Number(message.id),{...messages.get(Number(message.id)),...message});
 return [...messages.values()].sort((a,b)=>new Date(a.createdAt)-new Date(b.createdAt) || Number(a.id)-Number(b.id));
}
